/* istanbul ignore file */
/**
 * Select button component theme configuration.
 */

export const selectButtonComponentConfig = {
  selectbutton: {
    root: {
      borderRadius: '{border.radius.sm}',
    },
    colorScheme: {
      light: {
        root: {
          invalidBorderColor: '{form.field.invalid.border.color}',
        },
      },
      dark: {
        root: {
          invalidBorderColor: '{form.field.invalid.border.color}',
        },
      },
    },
  },
};
